
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import Puzzle from "../../modules/puzzle/Puzzle";
import useTranslation from "next-translate/useTranslation";
import { DailyPuzzlePageData, getPreloadedDailyPuzzle, preloadDailyPuzzle, } from "../../modules/puzzle/dailyPuzzlePrefetch";
function getParamValue(value: string | string[] | undefined) {
    return Array.isArray(value) ? value[0] : value;
}
export default function PuzzleDetailPage() {
    const { t } = useTranslation("puzzles");
    const router = useRouter();
    const id = useMemo(() => getParamValue(router.query.id as string | string[] | undefined), [router.query.id]);
    const [loadedPuzzle, setLoadedPuzzle] = useState<{
        id: string;
        data: DailyPuzzlePageData;
    } | null>(null);
    const [failedPuzzleId, setFailedPuzzleId] = useState<string | null>(null);
    const puzzleData = id
        ? getPreloadedDailyPuzzle(id) ??
            (loadedPuzzle?.id === id ? loadedPuzzle.data : null)
        : null;
    useEffect(() => {
        if (!router.isReady || !id)
            return;
        let cancelled = false;
        setFailedPuzzleId(null);
        preloadDailyPuzzle(id)
            .then((data) => {
            if (!cancelled)
                setLoadedPuzzle({ id, data });
        })
            .catch((error) => {
            if (cancelled)
                return;
            console.error("Error in puzzles", id, error);
            setFailedPuzzleId(id);
        });
        return () => {
            cancelled = true;
        };
    }, [id, router.isReady]);
    if (failedPuzzleId === id) {
        return <div className="flex justify-center p-8">{t("detail.notFound")}</div>;
    }
    if (!puzzleData) {
        return <div className="flex justify-center p-8">{t("detail.loading")}</div>;
    }
    return (<Puzzle key={id} puzzles={puzzleData.puzzles} nextPuzzleId={puzzleData.nextPuzzleId} index={false}/>);
}

    async function __Next_Translate__getStaticProps__1a0fc0d52c8__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzle/view',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d52c8__ as getStaticProps }
  